// The alert sound: a short two-note chime made with the Web Audio API (no sound file to load).
// Browsers only let a page play sound after the person has clicked or typed on it, so the audio is switched on at
// the first click or key press (unlockAlertSound) and a sound before that is skipped.
let audio = null;

export function unlockAlertSound() {
  const AudioContext = window.AudioContext || window.webkitAudioContext;
  if (!AudioContext) return;
  if (!audio) audio = new AudioContext();
  if (audio.state === "suspended") audio.resume().catch(() => {});
}

export function playAlertSound() {
  if (!audio || audio.state !== "running") return;
  const start = audio.currentTime + 0.02;
  [[880, 0], [1320, 0.16]].forEach(([frequency, delay]) => {
    const tone = audio.createOscillator();
    const volume = audio.createGain();
    tone.type = "sine";
    tone.frequency.value = frequency;
    volume.gain.setValueAtTime(0.0001, start + delay);
    volume.gain.exponentialRampToValueAtTime(0.25, start + delay + 0.02);
    volume.gain.exponentialRampToValueAtTime(0.0001, start + delay + 0.45);
    tone.connect(volume).connect(audio.destination);
    tone.start(start + delay);
    tone.stop(start + delay + 0.5);
  });
}
